import script from "./GenerateTalkView.vue?vue&type=script&setup=true&lang=js"
export * from "./GenerateTalkView.vue?vue&type=script&setup=true&lang=js"

import "./GenerateTalkView.vue?vue&type=style&index=0&id=56ecaea0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56ecaea0"]])

export default __exports__